<template>
  <div class="wrap">
    <div class="content">
      <div class="material-price">
        <div
          class="material-item"
          v-for="(item, index) in materialPurchaseList"
          :value="index"
          :key="index"
        >
          <div class="name">{{ item.material.name }}</div>
          <Input
            v-model="item.calcPurchaseUnitCost"
            style="width: 80px"
          ></Input>
          <!-- <div class="price">{{ item.calcPurchaseUnitCost }}</div> -->
        </div>
      </div>
      <div class="semiItem-wrap">
        <div
          class="semiItem-card"
          v-for="(card, index) in cardList"
          :key="card"
        >
          <SemiContrastCard
            @changeSemi="changeSemi"
            @closeCard="closeCard"
            :index="index"
            :materialPurchaseList="materialPurchaseList"
            ref="SemiContrastCard"
          />
        </div>
        <div class="addCard">
          <Icon type="ios-add" @click="addCard" size="100" color="#88D1F1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SemiContrastCard from "./SemiContrastCard.vue";

export default {
  name: "SemiContrast",
  components: { SemiContrastCard },
  data() {
    return {
      semiCardList: [],
      materialPurchaseList: [],
      cardList: [],
    };
  },
  computed: {
    ...mapState({
      semiItemList: (state) => state.semiItem.semiItemList,
    }),
  },
  methods: {
    ...mapActions({
      getSemiItem: "semiItem/getSemiItemAction",
    }),
    addCard() {
      this.cardList.push(String(new Date()));
    },
    changeSemi(originMaterialList, newMaterialList) {
      for (let i = 0; i < newMaterialList.length; i++) {
        const index = this.materialPurchaseList.findIndex((item) => {
          return item.material._id === newMaterialList[i].material._id;
        });

        if (index > -1) {
          this.materialPurchaseList[index].refCount++;
        } else {
          this.materialPurchaseList.push({
            ...newMaterialList[i],
            refCount: 1,
          });
        }
      }

      for (let i = 0; i < originMaterialList.length; i++) {
        const index = this.materialPurchaseList.findIndex((item) => {
          return item.material._id === originMaterialList[i].material._id;
        });

        if (index > -1) {
          this.materialPurchaseList[index].refCount--;
        }
      }

      // if (this.materialList.length <= 0) {
      //   data.forEach((item) => {
      //     item.total = 1;
      //   });
      //   this.materialList = this.materialList.concat(data);
      // } else {
      //   for (let i = 0; i < data.length; i++) {
      //     const index = this.materialList.findIndex((item) => {
      //       return item.material._id === data[i].material._id;
      //     });
      //     if (index > -1) {
      //       this.materialList[index].total = this.materialList[index].total + 1;
      //     } else {
      //       this.materialList.push(data[i]);
      //     }
      //   }
      // }
    },
    closeCard(index) {
      this.cardList.splice(index, 1);
    },
  },
  created() {
    this.getSemiItem();
  },
};
</script>
<style lang="stylus" scoped>
.content
  display flex

.material-price
  border 1px solid #000
  width 250px
  height 800px
  padding 16px

.material-item
  display flex
  justify-content space-between
  margin-bottom 15px

  .name
    line-height 32px
    font-size 17px

.material-item:hover
  border-bottom 1px solid #198EF6

.semiItem-wrap
  width 1444px
  display flex
  flex-flow wrap
  overflow-x auto

.addCard
  max-width 100px
  max-height 100px
  flex-shrink 0
  border 1px solid #3876E8
  cursor pointer
  border-radius 50%
  flex 1
  text-align center
  align-self center
  box-shadow 0px 0px 0px #409BE3
  transition box-shadow 0.2s ease-in-out
  margin-left 15px

.addCard:hover
  box-shadow 0px 0px 4px #409BE3
  transition box-shadow 0.2s ease-in-out

.close
  display flex
  justify-content flex-end
  cursor pointer
</style>